import { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getTheme,
  saveUserColor,
  getCurrentTheme,
  saveLogo,
  fetchLogo,
  getLogoSelector,
} from "../store/logoandcolor";
import * as theme from "../theme";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { toast } from "react-toastify";
import Dropzone from "react-dropzone";
import axios from "axios";
import { getBrokerInformation } from "../store/broker";
import {
  getBrokeragesList,
  loadBrokerages,
  brokerageSelected,
} from "../store/brokerages";

import ReactTooltip from "react-tooltip";
import { configIconDesc } from "../helper/constants";
import Select from "react-dropdown-select";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import translations from "../utils/translations";

const BrokerageAdminLogoAndColor = (props) => {
  const dispatch = useDispatch();
  const [selectedCode, setSelectedCode] = useState(null);
  const brokerages = useSelector(getBrokeragesList);
  const [dbLogo, setDbLogo] = useState("");
  const colorlist = useSelector(getTheme);
  const [selectedBrokerageName, setSelectedBrokerageName] = useState(
    "Search for a brokerage"
  );
  const broker = useSelector(getBrokerInformation);
  let brokerageCode = broker ? broker.information.brokerages[0].code : "";

  function getLogoCheck(code) {
    let url = process.env.REACT_APP_BASICSERVICE + "/api/logoandcolor/getlogo";
    axios
      .post(
        url,
        { brokerage_code: code.brokerage_code },
        {
          headers: { "X-Auth-Token": localStorage.getItem("jwt") },
        }
      )
      .then((res) => {
        if (res.data["logo"]) {
          let db_img_val = "data:image/png;base64," + res.data["logo"];
          if (res.data["logo"].includes("http")) {
            db_img_val = res.data["logo"];
          }
          setDbLogo(db_img_val);
        }
      });
  }
  useEffect(() => {
    dispatch(loadBrokerages());
    if (brokerageCode) {
      dispatch(getCurrentTheme({ brokerage_code: brokerageCode }));
      getLogoCheck({ brokerage_code: brokerageCode });
      setSelectedCode(brokerageCode);
    }
  }, [dispatch]);

  const onChangeHandle = (value) => {
    if (value[0]?.code) {
      dispatch(getCurrentTheme({ brokerage_code: value[0]?.code }));
      getLogoCheck({ brokerage_code: value[0]?.code });
      setSelectedCode(value[0].code);
      setSelectedBrokerageName(value[0].name);
    }
  };
  return (
    <div>
      {colorlist.length > 0 && (
        <LogoAndColor
          brokerageCode={selectedCode}
          dbLogo={dbLogo}
          colorlist={colorlist}
          setDbLogo={setDbLogo}
        ></LogoAndColor>
      )}
    </div>
  );
};

const LogoAndColor = (props) => {
  const dispatch = useDispatch();
  const colorlist = props.colorlist;

  const [colors, setColors] = useState({
    color1: colorlist[0]?.theme ? colorlist[0].theme.color1 : null,
    color2: colorlist[0]?.theme ? colorlist[0].theme.color2 : null,
    color3: colorlist[0]?.theme ? colorlist[0].theme.color3 : null,
  });
  const [upImg, setUpImg] = useState();
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const [crop, setCrop] = useState({
    unit: "px",
    width: 225,
    height: 217,
  });
  const [completedCrop, setCompletedCrop] = useState(null);
  const [themeChange, setThemeChange] = useState(false);
  const [imgCheckbox, setimgCheckbox] = useState(false);
  const [imgCheckboxText, setimgCheckboxText] = useState("Crop Image");

  let broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;
  const translationsBrokerAdmin =
    translations[languagepreference].brokerageAdmin;

  function colorSavehandler() {
    const newTheme = {
      color1: colors ? colors.color1 : colorlist[0]?.theme?.color1,
      color2: colors ? colors.color2 : colorlist[0]?.theme?.color2,
      color3: colors ? colors.color3 : colorlist[0]?.theme?.color3,
    };
    let data = {
      brokerage_code: props.brokerageCode,
      theme: newTheme,
    };
    dispatch(saveUserColor(data));
    toast.success(translationsBrokerAdmin.themeSavedSuccessfully);
  }

  function fileUploadhandler(canvas, crop) {
    var b64 = canvas.toDataURL("image");
    let data = {
      brokerage_code: props.brokerageCode,
      logo: b64,
    };
    dispatch(saveLogo(data));
    toast.success(translationsBrokerAdmin.logoSavedSuccessfully);
    props.setDbLogo(b64);
  }

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setUpImg(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");
    const pixelRatio = window.devicePixelRatio;

    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";
    if (imgCheckbox) {
      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );
      setimgCheckboxText("Crop Image");
    } else {
      setimgCheckboxText("Fit to Size");
      canvas.width = 304;
      canvas.height = 304;
      canvas.width = crop.width * pixelRatio;
      canvas.height = crop.height * pixelRatio;

      var ratioX = canvas.width / image.naturalWidth;
      var ratioY = canvas.height / image.naturalHeight;
      var ratio = Math.min(ratioX, ratioY);
      ctx.drawImage(
        image,
        0,
        0,
        image.naturalWidth * ratio,
        image.naturalHeight * ratio
      );
    }
  }, [completedCrop, imgCheckbox]);

  const updateField = (e) => {
    setColors((prevColors) => ({
      ...prevColors,
      [e.target.name]: e.target.value,
    }));
    setThemeChange(true);
  };

  const checkselectfile = (files) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => setUpImg(reader.result));
    reader.readAsDataURL(files[0]);
  };

  const dropzoneStyle = {
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
  };

  const colorselectorcommonStyle = {
    border: "2px solid black",
    width: "80px",
    height: "30px",
    margin: "0 auto",
  };

  const colorselectorStyle = {
    backgroundColor: colors
      ? colors.color1
      : colorlist[0]
      ? colorlist[0].theme.color1
      : "",
    backgroundColor: colors
      ? colors.color2
      : colorlist[0]?.theme
      ? colorlist[0].theme.color2
      : "",
    backgroundColor: colors
      ? colors.color3
      : colorlist[0]?.theme
      ? colorlist[0].theme.color3
      : "",
  };

  const iconsStyle = {
    margin: "0 1rem",
  };

  return (
    <div className="container" style={{ padding: "10px" }}>
      <div className="row p-3">
        <div className="col-2"></div>
        <div className="col-3">
          <p
            style={{ margin: "auto", textAlign: "center" }}
            className="font-weight-bold"
          >
            {translationsBrokerAdmin.colorEnterHex}
          </p>
        </div>
        <div className="col">
          <p
            style={{ margin: "auto", textAlign: "center" }}
            className="font-weight-bold"
          >
            {translationsBrokerAdmin.colorSelected}
          </p>
        </div>
      </div>
      <div className="row p-3">
        <div className="col-2">
          <p className="font-weight-bold">
            {translationsBrokerAdmin.colortSelect1}
          </p>
        </div>
        <div className="col-3">
          <input
            type="text"
            name="color1"
            className="form-control"
            placeholder="Enter hexcode"
            defaultValue={
              colorlist[0]?.theme ? colorlist[0]?.theme?.color1 : colors.color1
            }
            onChange={updateField}
          />
        </div>
        <div className="col" style={{ display: "flex" }}>
          <div
            data-tip="1"
            data-for="color-select-1"
            style={{
              ...colorselectorcommonStyle,
              backgroundColor: colors
                ? colors.color1
                : colorlist[0]
                ? colorlist[0].theme.color1
                : "",
            }}
          ></div>
          <div
            style={{
              display: "flex",
              maxWidth: "75%",
              maxHeight: "25vmin",
              fontSize: "0.7rem",
              color: "#212529",
            }}
          >
            {configIconDesc[9][languagepreference]}
          </div>
        </div>
      </div>
      <div className="row p-3">
        <div className="col-2">
          <p className="font-weight-bold">
            {translationsBrokerAdmin.colortSelect2}
          </p>
        </div>
        <div className="col-3">
          <input
            type="text"
            name="color2"
            className="form-control"
            placeholder="Enter hexcode"
            defaultValue={
              colorlist[0]?.theme ? colorlist[0].theme.color2 : colors.color2
            }
            onChange={updateField}
          />
        </div>

        <div className="col" style={{ display: "flex" }}>
          <div
            data-tip="1"
            data-for="color-select-1"
            style={{
              ...colorselectorcommonStyle,
              backgroundColor: colors
                ? colors.color2
                : colorlist[0]
                ? colorlist[0].theme.color2
                : "",
            }}
          ></div>
          <div
            style={{
              display: "flex",
              maxWidth: "75%",
              maxHeight: "25vmin",
              fontSize: "0.7rem",
              color: "#212529",
            }}
          >
            {configIconDesc[10][languagepreference]}
          </div>
        </div>
      </div>
      <div className="row p-3">
        <div className="col-2">
          <p className="font-weight-bold">
            {translationsBrokerAdmin.colortSelect3}
          </p>
        </div>
        <div className="col-3">
          <input
            type="text"
            name="color3"
            className="form-control"
            placeholder="Enter hexcode"
            defaultValue={
              colorlist[0]?.theme ? colorlist[0].theme.color3 : colors.color3
            }
            onChange={updateField}
          />
        </div>
        <div className="col" style={{ display: "flex" }}>
          <div
            data-tip="1"
            data-for="color-select-1"
            style={{
              ...colorselectorcommonStyle,
              backgroundColor: colors
                ? colors.color3
                : colorlist[0]
                ? colorlist[0].theme.color3
                : "",
            }}
          ></div>
          <div
            style={{
              display: "flex",
              maxWidth: "75%",
              maxHeight: "25vmin",
              fontSize: "0.7rem",
              color: "#212529",
            }}
          >
            {configIconDesc[11][languagepreference]}
          </div>
        </div>
      </div>
      <div className="row p-3">
        <div className="col-2"></div>
        <div className="col"></div>
        <div className="col">
          <Button
            style={{
              display: "flex",
              width: "100%",
              height: "100%",
              maxHeight: "6vmin",
              backgroundColor: theme.COLORS.secondary_skyblue,
              borderRadius: 5,
              color: "white",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "GibsonRegular",
              fontSize: "min(0.8vw, 15px)",
              letterSpacing: 1,
              border: 0,
            }}
            text="Save Theme"
            onClick={colorSavehandler}
            disabled={!themeChange}
          >
            {translationsBrokerAdmin.colorSaveTheme}
          </Button>
        </div>
      </div>
      <div className="row p-3">
        <div className="col-2">
          <p className="font-weight-bold">
            {" "}
            {translationsBrokerAdmin.colorAddLogo}
          </p>
        </div>
        <div className="col">
          <div>
            <Dropzone
              onDrop={(files) => checkselectfile(files)}
              accept="image/*"
              multiple={false}
            >
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <p style={dropzoneStyle}>
                      {translations[languagepreference].dragAndDrop}
                    </p>
                  </div>
                </section>
              )}
            </Dropzone>
          </div>
          <br />
          {upImg ? (
            <div>
              <ReactCrop
                src={upImg}
                onImageLoaded={onLoad}
                crop={crop}
                onChange={(c) => setCrop(c)}
                onComplete={(c) => setCompletedCrop(c)}
                locked={true}
              />
              <br />
              <Form.Check
                inline
                label={imgCheckboxText}
                name="group1"
                type="checkbox"
                id={`inline-checkbox-1`}
                onClick={(e) => {
                  setimgCheckbox(e.target.checked);
                }}
              />
              <p>{translationsBrokerAdmin.colorImagePreview}</p>
              <div>
                <canvas
                  ref={previewCanvasRef}
                  // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
                  style={{
                    width: Math.round(completedCrop?.width ?? 0),
                    height: Math.round(completedCrop?.height ?? 0),
                  }}
                />
              </div>
            </div>
          ) : null}
        </div>
        <div className="col">
          <Button
            style={{
              display: "flex",
              width: "100%",
              height: "100%",
              maxHeight: "6vmin",
              backgroundColor: theme.COLORS.secondary_skyblue,
              borderRadius: 5,
              color: "white",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "GibsonRegular",
              fontSize: "min(0.8vw, 15px)",
              letterSpacing: 1,
              border: 0,
            }}
            disabled={!completedCrop?.width || !completedCrop?.height}
            onClick={() =>
              fileUploadhandler(previewCanvasRef.current, completedCrop)
            }
          >
            {translationsBrokerAdmin.colorUpload}
          </Button>
        </div>
      </div>
      <div className="row p-3">
        <div className="col-2">
          <p className="font-weight-bold">
            {translationsBrokerAdmin.colorCurrentLogo}
          </p>{" "}
        </div>
        <div className="col-5"></div>
        <div className="col">
          {typeof props.dbLogo === "undefined" ? (
            "Loading ..."
          ) : props.dbLogo == "" ? (
            <p>{translationsBrokerAdmin.colorNoLogo}</p>
          ) : (
            <img src={props.dbLogo} alt="current logo" />
          )}
        </div>
      </div>
    </div>
  );
};

export default BrokerageAdminLogoAndColor;
